import { jsx } from 'react/jsx-runtime';
import { Badge } from 'baseui/badge';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle, mergeStyles } from '../../theme/utils.js';
import '../../theme/types.js';
import { mergeOverrides } from '../../overrides.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBadgeStyles = ({ $theme }, variant) => {
  const commonStyles = __spreadProps(__spreadValues({}, $theme.typography.ln2), {
    textTransform: "uppercase",
    paddingLeft: $theme.space[8],
    paddingRight: $theme.space[8],
    paddingTop: $theme.space[4],
    paddingBottom: $theme.space[4],
    height: "auto",
    color: $theme.colors["text-global-inverse"]
  });
  switch (variant) {
    case "secondary":
      return __spreadProps(__spreadValues({}, commonStyles), {
        backgroundColor: $theme.colors["background-brand-primary-light"]
      });
    case "tertiary":
      return __spreadProps(__spreadValues({}, commonStyles), {
        color: $theme.colors["text-brand-primary"],
        backgroundColor: $theme.colors["background-brand-tertiary"]
      });
    case "highlight":
      return __spreadProps(__spreadValues({}, commonStyles), {
        color: $theme.colors["text-brand-primary"],
        backgroundColor: $theme.colors["background-brand-highlight-primary"]
      });
    case "rejected":
      return __spreadProps(__spreadValues({}, commonStyles), {
        backgroundColor: $theme.colors["background-brand-error"]
      });
    case "discount":
      return __spreadProps(__spreadValues({}, commonStyles), {
        color: $theme.colors["text-brand-primary"],
        backgroundColor: $theme.colors["background-brand-notification-dot"]
      });
    case "disabled":
      return __spreadProps(__spreadValues({}, commonStyles), {
        color: $theme.colors["text-global-disabled"],
        backgroundColor: $theme.colors["background-brand-disabled"]
      });
    case "primary":
    default:
      return __spreadProps(__spreadValues({}, commonStyles), {
        backgroundColor: $theme.colors["background-brand-primary"]
      });
  }
};
const Tag = (_a) => {
  var _b = _a, { variant = "primary", overrides, $style } = _b, props = __objRest(_b, ["variant", "overrides", "$style"]);
  const _a2 = overrides || {}, { Tag: TagOverride } = _a2, defaultOverrides = __objRest(_a2, ["Tag"]);
  const resolvedStyles = useResolvedStyle($style);
  return jsx(Badge, __spreadValues({ overrides: mergeOverrides({
    Badge: {
      style: (styleProps) => mergeStyles(getBadgeStyles(styleProps, variant), resolvedStyles)
    }
  }, __spreadProps(__spreadValues({}, defaultOverrides), { Badge: TagOverride })) }, props));
};

export { Tag };
